<!--
 * @Description: 离散制造：方案优势
-->
<template>
  <div class="disperse_advantage rn-section-gap">
    <section>
      <!-- <div class="container"> -->
      <SectionTitle
        :title="$t('solution.advantages_title')"
        description="ADVANTAGES"
        textAlign="center"
      />
      <div class="advantage_card">
        <div class="advantage_bg_img">
          <div class="advantage_position">
            <div class="row justify-content-center">
              <div class="left_card">
                <div class="left_card_title">
                  <div class="card_title">
                    {{ $t("solution.disperse.advantages.left_tab.title") }}
                  </div>
                  <div class="left_card_icon">
                    <img
                      class="left_card_icon_img"
                      src="@/assets/images/IndustrySolution/disperse/disperse-icon-06.png"
                    />
                  </div>
                </div>
                <p class="card_desc_title">
                  {{ $t("solution.disperse.advantages.left_tab.description") }}
                </p>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div
                    v-for="(item, index) in list"
                    :key="index"
                    :class="
                      index === 0 || index === 4
                        ? 'col-lg-9 col-md-12 col-sm-12 col-12 offset-lg-3 right_card_position'
                        : index === 1 || index === 3
                        ? 'col-lg-8 col-md-12 col-sm-12 col-12 ptb--80 ptb_md--30 ptb_sm--25 offset-lg-4 right_card_position'
                        : 'col-lg-7 col-md-12 col-sm-12 col-12 offset-lg-5 right_card_position'
                    "
                  >
                    <div class="right_card">
                      <div
                        :class="
                          index === 0 || index === 4
                            ? 'right_card_icon pr--100'
                            : index === 1 || index === 3
                            ? 'right_card_icon pr--60'
                            : 'right_card_icon pr--90'
                        "
                      >
                        <img
                          class="right_card_icon_img"
                          src="@/assets/images/IndustrySolution/disperse/disperse-icon.png"
                        />
                      </div>
                      <div class="card_content pl_md--30">
                        <div class="card_icon d-none d-sm-block">
                          <img class="card_icon_img" :src="item.img" />
                        </div>
                        <div class="solution_position title s_title pr--50 pr_sm--0">
                          <div class="card_content2">
                            <div class="card_icon2 d-blok d-sm-none">
                              <img
                                class="card_icon_img2"
                                :src="item.img"
                              />
                            </div>
                            <div class="f_title">{{ item.title }}</div>
                          </div>
                          <p class="s_title">{{ item.desc }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </section>
  </div>
</template>

<script>
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'
export default {
  name: 'DisperseAdvantage',
  components: { SectionTitle },
  props: {

  },
  data () {
    return {
      list: [
        { img: require('@/assets/images/IndustrySolution/disperse/disperse-icon-01.png'), title: this.$t("solution.disperse.advantages.right_tab.tab01_title"), desc: this.$t("solution.disperse.advantages.right_tab.tab01_description") },
        { img: require('@/assets/images/IndustrySolution/disperse/disperse-icon-02.png'), title: this.$t("solution.disperse.advantages.right_tab.tab02_title"), desc: this.$t("solution.disperse.advantages.right_tab.tab02_description") },
        { img: require('@/assets/images/IndustrySolution/disperse/disperse-icon-03.png'), title: this.$t("solution.disperse.advantages.right_tab.tab03_title"), desc: this.$t("solution.disperse.advantages.right_tab.tab03_description") },
        { img: require('@/assets/images/IndustrySolution/disperse/disperse-icon-04.png'), title: this.$t("solution.disperse.advantages.right_tab.tab04_title"), desc: this.$t("solution.disperse.advantages.right_tab.tab04_description") },
        { img: require('@/assets/images/IndustrySolution/disperse/disperse-icon-05.png'), title: this.$t("solution.disperse.advantages.right_tab.tab05_title"), desc: this.$t("solution.disperse.advantages.right_tab.tab05_description") },
      ]
    }
  },
  methods: {

  }
}
</script>